import React, { Component } from 'react';
import { timePrefixZeroFromSeconds, secondsDiff } from '../../utilities/timeUtility';
import Icon from '../Icon';

export default class Timer extends Component {
  state = {
    seconds: this.secondsFromProps(),
    timerId: 0,
  };

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  secondsFromProps() {
    const { seconds, expiresAt } = this.props;
    if (seconds) return seconds;
    if (expiresAt) return secondsDiff(expiresAt);
    return 0;
  }

  startTimer() {
    if (!this.state.timerId) {
      const timerId = setInterval(() => {
        if (this.state.seconds <= 0) {
          this.stopTimer();
          this.props.onExpired();
        } else {
          this.setState((prevState) => ({ seconds: prevState.seconds - 1 }));
        }
      }, window.bta.test ? 0 : 1000);

      this.setState({ timerId });
    }
  }

  stopTimer() {
    clearInterval(this.state.timerId);
    this.setState({ timerId: 0 });
  }

  render() {
    return (
      <div data-testid="timer-element">
        <Icon iconName="clock" style={{ marginRight: '7px' }} />
        {timePrefixZeroFromSeconds(this.state.seconds)}
      </div>
    );
  }
}
